import { addDays, format, parseISO, subDays } from 'date-fns';

import { Regulations } from '@/api/fishrules/getSpeciesRegulationsAtLocation';

const formatDate = (date: Date): string => format(date, 'MMMM d');

export type SeasonBadge = { label: string; isOpen: boolean };

export const getSeasonBadge = (
  seasons: Regulations['seasons'],
  referenceDate: Date,
): SeasonBadge => {
  if (!seasons.length) {
    return { label: 'Season open: year-round', isOpen: true };
  }
  const current = seasons.find(
    s => parseISO(s.starts_at.date) <= referenceDate && referenceDate <= parseISO(s.ends_at.date),
  );
  if (current) {
    return {
      label: `Season closed: ${formatDate(parseISO(current.starts_at.date))} - ${formatDate(parseISO(current.ends_at.date))}`,
      isOpen: false,
    };
  }
  const sorted = [...seasons].sort(
    (a, b) => parseISO(a.starts_at.date).getTime() - parseISO(b.starts_at.date).getTime(),
  );
  const nextClosed = sorted.find(s => parseISO(s.starts_at.date) > referenceDate) ?? sorted[0];
  const prevClosed =
    [...sorted].reverse().find(s => parseISO(s.ends_at.date) < referenceDate) ??
    sorted[sorted.length - 1];
  if (!nextClosed || !prevClosed) {
    return { label: 'Season open: year-round', isOpen: true };
  }
  const openStart = addDays(parseISO(prevClosed.ends_at.date), 1);
  const openEnd = subDays(parseISO(nextClosed.starts_at.date), 1);
  return {
    label: `Season open: ${formatDate(openStart)} - ${formatDate(openEnd)}`,
    isOpen: true,
  };
};
